const AiSearchKeys = {
  global: ["aiSearch"] as const,
  conversation: (id: string) =>
    [...AiSearchKeys.global, "conversation", id] as const,
  temporaryConversation: () => [...AiSearchKeys.conversation("temp")] as const,

  /* Mutation key */
  submit: ["aiSearchSubmit"] as const,
};

export { AiSearchKeys };
